import { Field } from 'formik';
import { FsProps, CustomSelectComponent, FormCol6 } from 'motion-components';
import React from 'react';

// 1;field;bmsCharacterization;enum('safe_for_transport','not_safe_for_transport','no_information');;Χαρακτηρισμός μπαταρίας σύμφωνα με BMS;B.1;
export const FieldSelectBmsCharacterization = ({
  label = 'Χαρακτηρισμός μπαταρίας σύμφωνα με BMS;',
  name = 'xrbData.bmsCharacterization',
  helpText = '',
  ...rest
}: FsProps & { helpText?: string | React.ReactNode }) => {
  const options = [
    { value: 'safe_for_transport', label: 'SAFE FOR TRANSPORT' },
    { value: 'conditionally_safe_for_transport', label: 'CONDITIONALLY SAFE FOR TRANSPORT' },
    { value: 'no_information', label: 'NO INFORMATION' },
    { value: 'other', label: 'OTHER' },
  ];
  return (
    <Field
      name={name}
      title={label}
      component={(props) => (
        <CustomSelectComponent {...props} as={FormCol6} className="mb-0" helpText={helpText} />
      )}
      options={options}
      useCreatableSelect={true}
      {...rest}
    />
  );
};
